import { pode } from '../../authorization/pode';
import { useVeredito } from '../../authorization/useVeredito';
import type { FamiliaDeAplicacao } from '../../services/efetivosService';

/**
 * O que o perfil pode fazer com as aplicações de uma família. Quem só lê vê o inventário sem
 * incluir, editar nem remover — a ação some, em vez de aparecer e terminar em recusa.
 */
export interface PermissoesDaAplicacao {
  incluir: boolean;
  editar: boolean;
  remover: boolean;
}

export const TODAS_AS_PERMISSOES: PermissoesDaAplicacao = { incluir: true, editar: true, remover: true };

const TELA_DA_FAMILIA: Record<FamiliaDeAplicacao, string> = {
  risk: '/risk-applications',
  source: '/source-applications',
  exam: '/exam-applications',
};

export function usePermissoesDaAplicacao(familia: FamiliaDeAplicacao): PermissoesDaAplicacao {
  const tela = TELA_DA_FAMILIA[familia];
  const prefixo = `${familia}_application`;
  return {
    incluir: useVeredito(tela, pode(`${prefixo}.create`)).liberado,
    editar: useVeredito(tela, pode(`${prefixo}.update`)).liberado,
    remover: useVeredito(tela, pode(`${prefixo}.delete`)).liberado,
  };
}
